// extracted by mini-css-extract-plugin
export default {"navArrowsContainer":"AuctionNavigation_navArrowsContainer__hu+XO","leftArrowCool":"AuctionNavigation_leftArrowCool__MhoSC","rightArrowCool":"AuctionNavigation_rightArrowCool__q8LV+"};